import { history } from "../../../../helpers/history";
import { formConstants } from "../../../../constants/cms/form/form.constants";
import { elementActions } from "../../../actions/cms/element/element.action";
import { templateActions } from "../../../actions/cms/template/template.action";
import { alertActions } from "../../alert.action";
import { formService } from "../../../../services/cms/form/form.service";
import {
  checkForFormUpdates,
  deepClone
} from "../../../../helpers/objectHelper";

import { store } from "../../../configureStore";
import { formSettings } from "../../../../cms/areas/form/models/formSettings";
import { cms } from "../../../reducers/cms/cms.reducer";
import { cmsActions } from "../cms.action";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { attendeeActions } from "../../attendee/attendee.action";
import { attendeeConstants } from "../../../../constants/attendee/attendee.constants";
export const formActions = {
  attach,
  update,
  get,
  select,
  removePage,
  softUpdate,
  remove,
  addPage,
  scrollPage,
  transfer,
  deselect,
  create,
  getAll,
  post,
  selectOption,
  formIsValid,
  updateFormElement,
  deleteForm,
  restore,
  getSurvey,
  postSurvey,
  removeOrderByCondition,
  // setSqlState,
  checkForUpdates,
  getAllPaths,
  crop
};

//#region CLIENT ACTIONS

function formIsValid(state) {
  return dispatch => {
    dispatch(success(state));
  };
  function success(element) {
    return { type: formConstants.FORM_IS_VALID, state };
  }
}
function crop(isCropping) {
  return dispatch => {

    dispatch(success(isCropping));
  };
  function success(isCropping) {
    return { type: formConstants.IS_CROPPING, isCropping };
  }
}
function attach(element) {
  return dispatch => {
    dispatch(success(element));
  };
  function success(element) {
    return { type: formConstants.ATTACH_SUCCESS, element };
  }
}
function scrollPage(page, callback) {
  return dispatch => {
    dispatch(success(page));
  };
  function success(page) {
    return { type: formConstants.SCROLL_PAGE, page };
  }
}
function restore() {
  return dispatch => {
    dispatch(success());
  };
  function success() {
    return { type: formConstants.RESTORE_FORM };
  }
}
function addPage() {
  return dispatch => {
    dispatch(success());
  };
  function success() {
    return { type: formConstants.ADD_PAGE };
  }
}
function removePage() {
  return dispatch => {
    dispatch(success());
  };
  function success() {
    return { type: formConstants.REMOVE_PAGE };
  }
}
function updateFormElement(element, conditionCheck = false) {
  const form = store.getState().form;
  return dispatch => {
    if ((element.props && element.props.inherit !== null) || form.inherit == true ) {
      dispatch(cmsActions.inheritageAffected(true));
    }
    dispatch(success({ ...element, hasChanged: true }, conditionCheck));
  };
  function success(element, conditionCheck, reCreation) {
    return { type: formConstants.UPDATE_FORM_ELEMENT, element, conditionCheck };
  }
}
function deselect() {
  return dispatch => {
    dispatch(success());
  };
  function success() {
    return { type: formConstants.DESELECT_SUCCESS };
  }
}
function remove(element) {
  return dispatch => {
    dispatch(success(element));
  };
  function success(element) {
    return { type: formConstants.DELETE_SUCCESS, element };
  }
}
function selectOption(option) {
  return dispatch => {
    dispatch(success(option));
  };
  function success(option) {
    return { type: formConstants.SELECT_OPTION, option };
  }
}
var updateSqlStateTimeout;
function removeOrderByCondition(eventId) {
  if (updateSqlStateTimeout) {
    clearTimeout(updateSqlStateTimeout);
  }
  updateSqlStateTimeout = setTimeout(attendeeActions.updateSqlState, 500);

  return { type: attendeeConstants.REMOVE_ORDER_BY_CONDITION, eventId };
}
function select(element) {
  return dispatch => {
    dispatch(success(element));
  };
  function success(element) {
    return { type: formConstants.SELECT_SUCCESS, element };
  }
}
function softUpdate(form, reCreation = false) {
  return dispatch => {
    if (form.inherit == true) {
      dispatch(cmsActions.inheritageAffected(true));
    }
    dispatch(success(form, reCreation));
  };
  function success(form, reCreation) {
    return { type: formConstants.SOFT_UPDATE_SUCCESS, form, reCreation };
  }
}
function transfer(element) {
  return dispatch => {
    dispatch(success(element));
  };
  function success(element) {
    return { type: formConstants.TRANSFER_SUCCESS, element };
  }
}
//#endregion

//#region SERVER ACTIONS
function checkForUpdates(form, allowOverWrite = false) {
  return dispatch => {
    dispatch(alertActions.clear());

    /*  if (allowOverWrite) {
       return dispatch(update(form));
     } */

    const newForm = stringifyForm(form);
    return dispatch(update(form));
    /*   formService.checkForUpdates(newForm).then(
        data => {
          if (data.isModified === true) {
            return dispatch(
              cmsActions.alertNewModifications(data.isModified, "FORM")
            );
          } else {
            return dispatch(update(form));
          }
        },
        error => {
          dispatch(alertActions.error(error));
        }
      );  */
  };
}
function update(form) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    const newForm = stringifyForm(form);

    formService.update(newForm).then(
      formResponse => {
        dispatch(success(formResponse));
        if (formResponse.formId != form.formId) {
          history.push('/cms/form/' + formResponse.formId);
        }
        /*         formService.screenshot(newForm.formId, newForm.pages) */
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: formConstants.UPDATE_FORM_REQUEST };
  }
  function success(form) {
    return { type: formConstants.UPDATE_FORM_SUCCESS, form };
  }
  function failure(error) {
    return { type: formConstants.UPDATE_FORM_FAILURE, error };
  }
}
function getAll(eventId, isSurvey) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    formService.getAll(eventId, isSurvey).then(
      forms => {
        dispatch(success(forms));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request() {
    return { type: formConstants.GETALL_FORM_REQUEST };
  }
  function success(forms) {
    return { type: formConstants.GETALL_FORM_SUCCESS, forms };
  }
  function failure(error) {
    return { type: formConstants.GETALL_FORM_FAILURE, error };
  }
}
function getSurvey(code) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    formService.getSurvey(code).then(
      form => {
        if(form.isAnswered === true){
          window.location.replace(window.location.origin + (!window.location.href.includes("localhost") ? '/cms' : '') +  `/p/${form.redirectId}`);
        }
        else{
          form.settings = JSON.parse(form.settings);
          form.settings = checkForFormUpdates(form.settings, formSettings);
          dispatch(success(form));
        }
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
        if (error.includes("JX_SURVEY_ISANSWERED")) {
          history.push("/isanswered");
        }
      }
    );
  };

  function request() {
    return { type: formConstants.GET_FORM_REQUEST };
  }
  function success(form, editMode) {
    return { type: formConstants.GET_FORM_SUCCESS, form, editMode };
  }
  function failure(error) {
    return { type: formConstants.GET_FORM_FAILURE, error };
  }
}
function get(formId, editMode, registerMode = false) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    let item = localStorage.getItem("formstates");
    let prevStateNo = undefined;
    if (item) {
      let states = JSON.parse(item);
      let prevState = states.find(
        s => s.formId === formId && s.expires > Date.now()
      );
      if (prevState) {
        prevStateNo = prevState.sqlStateNo;
      }
    }

    formService.get(formId, registerMode, prevStateNo === undefined).then(
      form => {
        form.settings = JSON.parse(form.settings);
        form.settings = checkForFormUpdates(form.settings, formSettings);
        if (/* !registerMode && */ form.settings.submit !== undefined
          && Array.isArray(form.settings.submit.labels) && form.settings.submit.labels.length === 0) {
          form.settings = attachLabel("submit", form);
        }
        if (
          form.settings.navigation.next !== undefined
          && Array.isArray(form.settings.navigation.next.labels) && form.settings.navigation.next.labels.length === 0
        ) {
          form.settings = attachLabel("navigation.next", form);
        }
        if (
          form.settings.navigation.previous !== undefined
          && Array.isArray(form.settings.navigation.previous.labels) && form.settings.navigation.previous.labels.length === 0
        ) {
          form.settings = attachLabel("navigation.previous", form);
        }
        if (prevStateNo !== undefined) {
          form.sqlStateNo = prevStateNo;
        }
        dispatch(success(form, editMode));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: formConstants.GET_FORM_REQUEST };
  }
  function success(form, editMode) {
    return { type: formConstants.GET_FORM_SUCCESS, form, editMode };
  }
  function failure(error) {
    return { type: formConstants.GET_FORM_FAILURE, error };
  }
}
function post(orders, formId) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    formService.post(orders).then(
      response => {
        let item = localStorage.getItem("formstates");
        if (item) {
          let states = JSON.parse(item);
          let prevState = states.find(
            s => s.formId === formId && s.expires > Date.now()
          );
          if (prevState) {
            states.splice(states.indexOf(prevState), 1);
            localStorage.setItem("formstates", JSON.stringify(states))
          }
        }
        window.location.replace(window.location.origin + (!window.location.href.includes("localhost") ? '/cms' : '') + response.redirectUrl);
        /*         history.push(response.redirectUrl); */
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: formConstants.POST_FORM_REQUEST };
  }
  function failure(error) {
    return { type: formConstants.POST_FORM_FAILURE, error };
  }
}
function postSurvey(orders) {
  return dispatch => {
    dispatch(alertActions.clear());
    // const newForm = deepClone(form);
    // newForm.settings = JSON.stringify(newForm.settings);
    // newForm.formElements.map(e => {
    //   let newEl = deepClone(e);
    //   newEl.data = JSON.stringify(newEl.data);
    //   return newEl;
    // });
    formService.postSurvey(orders).then(
      result => {
        window.location.replace(window.location.origin + (!window.location.href.includes("localhost") ? '/cms' : '') +  `/p/${result.confId}`);
      
      },
      error => {
        dispatch(alertActions.error(error));
      }
    );
  };
}

function getAllPaths(eventId) {
  return dispatch => {
    dispatch(alertActions.clear());
    formService.getAllPaths(eventId).then(
      forms => {
        dispatch(set(forms));
      },
      error => {
        dispatch(alertActions.error(error));
      }
    );
  };

  function set(forms) {
    return { type: formConstants.GET_ALL_FORM_PATHS, forms };
  }
}

function create(form, eventId) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    const newForm = deepClone(form);
    newForm.settings = JSON.stringify(newForm.settings);
    formService.create(newForm).then(
      form => {
        dispatch(getAll(form.eventId, form.survey));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: formConstants.CREATE_FORM_REQUEST };
  }
  function success(form) {
    return { type: formConstants.CREATE_FORM_SUCCESS, form };
  }
  function failure(error) {
    return { type: formConstants.CREATE_FORM_FAILURE, error };
  }
}

function deleteForm(formId, eventId) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    formService.deleteForm(formId).then(
      _ => {
        dispatch(success(formId));
        dispatch(getAll(eventId));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: formConstants.DELETE_FORM_REQUEST };
  }
  function success(form) {
    return { type: formConstants.DELETE_FORM_SUCCESS, form };
  }
  function failure(error) {
    return { type: formConstants.DELETE_FORM_FAILURE, error };
  }
}

// function setSqlState(stateNo, eventId, state) {
//   return dispatch => {
//     dispatch(alertActions.clear());
//     formService.setSqlState(stateNo, eventId, state).then(
//       _ => { },
//       error => {
//         dispatch(failure(error));
//         dispatch(alertActions.error(error));
//       }
//     );
//   };
//   function failure(error) {
//     return { type: formConstants.SET_STATE_ERROR, error };
//   }
// }
//#endregion

//#region UTILITIES
function stringifyForm(form) {
  const newForm = deepClone(form);
  newForm.formElements = form.formElements.map(el => {
    let newEl = deepClone(el);
    if (
      newEl.type == elementConstants.PAYMENT_OPTIONS &&
      typeof newEl.data === "object"
    ) {
      newEl.data.selectedPaymentMethod = "";
    }
    newEl.data = JSON.stringify(newEl.data);
    return newEl;
  });
  newForm.settings = JSON.stringify(form.settings);
  return newForm;
}
function attachLabel(path, form) {
  const names = path.split(".");
  const settings = deepClone(form.settings);
  let codes = store.getState().language.eventCodes;
  if (!codes) {
    codes = ["swe", "eng"];
  }

  const labels = [];

  for (let i = 0; i < codes.length; i++) {
    labels.push({
      text: "",
      languageCode: codes[i],
      isValid: false
    });
  }

  if (names.length === 1) {
    settings[names[0]].labels = labels;
  } else if (names.length === 2) {
    settings[names[0]][names[1]].labels = labels;
  }
  return settings;
}
//#endregion
